export type UltraCheckoutParams =
  | {
      refl: 'obsplugin-theme-library';
      source: 'library-overlays';
      ref_item: number;
      aff_id: number;
    }
  | {
      refl: 'obsplugin-widget-library';
      source: 'library-widget-themes';
      ref_item: number;
      aff_id: number;
    }
  | {
      refl:
        | 'obsplugin-multistream'
        | 'obsplugin-left-nav'
        | 'obsplugin-onboarding'
        | 'obsplugin-golive';
    };

export const getUltraUrl = (
  params: UltraCheckoutParams,
  goToCheckout = true,
) => {
  const url = goToCheckout
    ? new URL('https://www.streamlabs.com/checkout-redirect')
    : new URL('https://www.streamlabs.com/ultra');

  if (params) {
    for (const [p, v] of Object.entries(params)) {
      url.searchParams.set(p, v);
    }
  }

  return url.toString();
};
